export const container = {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexFlow: 'column',
    justifyContent: 'center',
    alignItems: 'center'
}

export const box = {
    width: '100%',
    height: '100%',
    backgroundColor: '#D9D9D9',
    borderRadius: '5px'
}

export const rows = {
    width: '100%',
    height: '90%',
    display: 'flex',
    justifyContent: 'center'
}

export const fieldset = {
    width: "100%",
    height: "100%",
    margin: '20px 20px 0px 20px',
    padding: '20px',
    borderRadius: '10px'
}

export const oini = {
    alignItems: 'center'
}

export const delay = {
    marginTop: '18px',
    alignItems: 'center'
}

export const button = {
    display: 'flex',
    alignItems: 'end',
    justifyContent: 'end',
    width: '100%',
    height: '10%',
    padding: '10px'
}
